export interface FieldErrorDetail {
  param?: string | null;
  context?: string | null;
}

export interface FieldError {
  element?: string | null;
  context?: string | null;
  details?: FieldErrorDetail | readonly FieldErrorDetail[] | readonly FieldError[] | null;
}

interface GetFieldErrorsOptions {
  errors?: readonly FieldError[] | null;
  forElement?: string | null;
  context?: string | null;
}

export default function getFieldErrors(
  props: GetFieldErrorsOptions | null = {},
): Array<FieldError | FieldErrorDetail> | false {
  if (!props) {
    return false;
  }
  const { errors = null, forElement = null, context = null } = props;
  const fieldErrors = errors
    ?.map((error) => {
      const { element = 'none', details } = error;
      if (element === forElement) {
        if (context && error.context !== context) {
          return false;
        }
        return error;
      }
      if (details) {
        const found = (Array.isArray(details) ? details : [details]).find((detail) => {
          if (context && error.context !== context && detail.context !== context) {
            return false;
          }
          return detail.param === forElement;
        });
        if (found) {
          return found;
        }
      }
      return false;
    })
    .filter((error) => error);
  if (!fieldErrors || fieldErrors.length <= 0) {
    return false;
  }
  return fieldErrors;
}
